var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourseHistoryCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.72151 2.30989H8.92677V1.14177C8.92677 0.762124 9.2188 0.440889 9.62765 0.440889C10.0073 0.440889 10.3285 0.762124 10.3285 1.14177V2.30989H11.4967C12.5188 2.30989 13.3657 3.15679 13.3657 4.1789V13.5239C13.3657 14.5752 12.5188 15.3929 11.4967 15.3929H2.15163C1.10031 15.3929 0.282623 14.5752 0.282623 13.5239V4.1789C0.282623 3.15679 1.10031 2.30989 2.15163 2.30989H3.31976V1.14177C3.31976 0.762124 3.61179 0.440889 4.02063 0.440889C4.40028 0.440889 4.72151 0.762124 4.72151 1.14177V2.30989ZM1.68438 13.5239C1.68438 13.7868 1.8888 13.9912 2.15163 13.9912H11.4967C11.7303 13.9912 11.9639 13.7868 11.9639 13.5239V6.0479H1.68438V13.5239Z",
    fill: "#B2B2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseHistoryCalendar);
export default __webpack_public_path__ + "static/media/Course-history-Calendar.dee1430b773562f7e3872a54fcaa56e3.svg";
export { ForwardRef as ReactComponent };